// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2f-6";
export var headerCell = "_2f-2";
export var loadingStateContent = "_2f-8";
export var rowWrapper = "_2f-4";
export var stickyAggregationCell = "_2f-b";
export var stickyAggregationRow = "_2f-7";
export var stickyColumnCell = "_2f-a";
export var stickyColumnHeaderCell = "_2f-9";
export var table = "_2f-1";
export var virtualRowWrapper = "_2f-5";
export var virtualTableContainer = "_2f-0";
export var white = "_2f-3";